module.exports = __webpack_public_path__ + "static/media/icon-file-excel.459da0e4.svg";